export const cleanContent = (content) => {
  return content;
}

export const formatContentOnChange = (content, cb) => {
  cb(content);
}